import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

export default function FilePreviewModal({  modal, setModal, filePath, fileName}) {  
  return (
    <>
      <Modal
        size="lg"
        isOpen={modal}
        className="custom-modal"
        style={{ zIndex: 2000 }}
        centered
        // centered={false}
        // scrollable={false}
        // fade={false}
        toggle={() => setModal(false)}
      >
        <ModalHeader toggle={() => setModal(false)}>
          {fileName}
        </ModalHeader>
        <ModalBody style={{ width: '850px', height: '500px', alignContent: 'center' }}>
          <div style={{ alignContent: 'center' }}>
            { ['jpg', 'jpeg', 'png', 'gif'].includes(filePath?.split('.').pop().toString()) ?
              <img alt="" src={filePath} style={{ width: '770px', height: '450px' }} /> :
              (
                ['mp4', 'avi', 'mkv', 'mov', 'wmv'].includes(filePath?.split('.').pop().toString()) ?
                  <video width="750" height="450" controls controlsList="nodownload">
                    <source src={filePath} type={`video/${filePath?.split('.').pop().toString()}`} />
                  </video>
                  :
                <iframe title="PDF Viewer" src={`https://docs.google.com/viewer?url=${encodeURIComponent(filePath)}&embedded=true`} style={{ width: '770px', height: '450px' }} width="100%" height="100%" frameBorder="0" scrolling="no" />
              )
            }
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}